import { render, staticRenderFns } from "./PreviewPage.vue?vue&type=template&id=2009481a&"
import script from "./PreviewPage.vue?vue&type=script&lang=js&"
export * from "./PreviewPage.vue?vue&type=script&lang=js&"
import style0 from "./PreviewPage.vue?vue&type=style&index=0&id=2009481a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports